import { message } from "antd";
import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext<any>(null!);

function getInitialUser() {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
}

function getInitialSite() {
  const station = localStorage.getItem("site");
  return station ? JSON.parse(station) : null;
}


function getInitialDates() {
  const dates = localStorage.getItem("dates");
  return dates ? JSON.parse(dates) : null;
}

function getInitialAuth() {
  const auth = localStorage.getItem("auth");
  return auth ? JSON.parse(auth) : null;
}

function getInitialToken() {
  const token = localStorage.getItem("token");
  return token ? token : null;
}

const AuthProvider = ({ children, location }: any) => {
  const [user, setUser] = useState<any>(getInitialUser);
  const [site, setSite] = useState<any>(getInitialSite);
  const [dates, setDates] = useState<any>(getInitialDates);
  const [token, setToken] = useState<any>(getInitialToken);
  const [auth, setAuth] = useState<boolean>(getInitialAuth);

  const navigate = useNavigate();


  const updateSite = (site: any) => {
    localStorage.setItem("site", JSON.stringify(site));
    setSite(site);
  };

  const updateDates = (dates: any) => {
    localStorage.setItem("dates", JSON.stringify(dates));
    setDates(dates);
  };

  const signin = (payload: any) => {
    const { user, auth, token } = payload;
    if (token) {
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("auth", JSON.stringify(user));
      localStorage.setItem("token", token);
      setToken(token);
      setUser(user);
      setAuth(auth);
    }
    navigate("/dashboard");
  };

  const signout = () => {
    localStorage.setItem("user", "");
    localStorage.setItem("token", "");
    setUser(null);
    setToken(null);
    navigate("/");
    message.success("Logged out successfully");
  };

  const handleFetchAuth = async () => {
    if (token) {
      setToken(token);
    }
  };

  let value = {
    user,
    setUser,
    token,
    setToken,
    auth,
    setAuth,
    signin,
    signout,
    site,
    updateSite,
    dates,
    updateDates
  };

  useEffect(() => {
    handleFetchAuth();
  }, []);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export { AuthContext, AuthProvider };
